export default __webpack_public_path__ + "static/support-402642994c0c1048ba1ef75ef71c90fd.svg";